import menu from "./menu";
import router from "./router";

export default {
    menu,
    router
};
